export { default } from "./SharePermission";
